import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed, watch } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';

import {
    MultiSelectOption,
    WordGetters,
    WordActions,
    WordFilter,
    CallParticipantType,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'WordListFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const filtersOpened = ref(false);

const defaultFilter = computed(() => store.getters[WordGetters.DEFAULT_FILTER]);

const filter: Ref<WordFilter> = ref({
    callParticipant: defaultFilter.value.callParticipant,
    isActive: defaultFilter.value.isActive,
});

const storeFilters = computed<WordFilter>(() => store.getters[WordGetters.FILTER]);

const callParticipantTypeFilterOptions = [
    {
        value: CallParticipantType.Agent,
        label: t(`word.participant.${CallParticipantType.Agent}`),
    },
    {
        value: CallParticipantType.Client,
        label: t(`word.participant.${CallParticipantType.Client}`),
    },
] as MultiSelectOption[];

const isActiveFilterOptions = [
    {
        label: t('word.filters.isActive.options.active'),
        value: true,
    },
    {
        label: t('word.filters.isActive.options.inactive'),
        value: false,
    },
] as MultiSelectOption[];

function applyFilters() {
    store.dispatch(WordActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(WordActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    filter.value.callParticipant = storeFilters.value.callParticipant;
    filter.value.isActive = storeFilters.value.isActive;
}

watch(filtersOpened, () => {
    refreshLocalFilter();
});

const __returned__ = { t, filtersOpened, defaultFilter, filter, storeFilters, callParticipantTypeFilterOptions, isActiveFilterOptions, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})